import React from 'react';
import { Helmet } from 'react-helmet';

const AboutUs = () => {
  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", lineHeight: '1.6', color: '#333', background: '#f5f5f5', minHeight: '100vh' }}>
      <Helmet>
        <title>About SugarHathi — Villgrains FarmTech Pvt Ltd</title>
        <meta name="description" content="Learn about SugarHathi, India's integrated digital sugar economy platform built by Villgrains FarmTech Private Limited." />
      </Helmet>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', background: 'white', minHeight: '100vh' }}>

        <div style={{ textAlign: 'center', marginBottom: '40px', paddingBottom: '20px', borderBottom: '3px solid #2ecc71' }}>
          <h1 style={{ fontSize: '2.5rem', color: '#2ecc71', margin: '0 0 10px 0', padding: 0 }}>About Us</h1>
          <p style={{ color: '#666', fontSize: '0.95rem', margin: 0 }}><strong style={{ color: '#2c3e50' }}>Villgrains FarmTech Private Limited</strong></p>
        </div>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>Who We Are</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Villgrains FarmTech Private Limited operates <strong style={{ color: '#2c3e50' }}>SugarHathi</strong> — 
            a digital platform connecting sugar factories, buyers, and transporters across India.
            We bring transparency, speed, and trust to agricultural commodity trading.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>What We Do</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            SugarHathi enables buyers to discover, book, and track sugar deliveries directly from
            verified factories. Our platform handles the entire process — from quota listing to
            delivery confirmation — digitally and transparently.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>Our Mission</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            To make sugar trading simple, transparent, and accessible for every factory, buyer,
            and transporter in India.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>Company Details</h2>
          <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', margin: '15px 0' }}>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Legal Name:</strong> Villgrains FarmTech Private Limited</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>CIN:</strong> U01100TG2023PTC168433</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>GSTIN:</strong> 36AAICV4489R1Z6</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Registered Office:</strong> 101B, Vishnu Acharya Nivas, Road No 3, Journalist Colony, Banjara Hills, Hyderabad, Telangana - 500034</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Email:</strong> info@villagegrains.com</p>
            <p style={{ marginBottom: 0 }}><strong style={{ color: '#2c3e50' }}>WhatsApp:</strong> +91 79899 53468</p>
          </div>
        </section>

        <div style={{ textAlign: 'center', marginTop: '50px', paddingTop: '30px', borderTop: '2px solid #e0e0e0', color: '#666', fontSize: '0.9rem' }}>
          <p style={{ marginBottom: '5px' }}>&copy; 2026 Villgrains FarmTech Private Limited. All rights reserved.</p>
          <p style={{ margin: 0 }}>Trading as SugarHathi</p>
        </div>

      </div>
    </div>
  );
};

export default AboutUs;
